<router-outlet></router-outlet>

<app-loading></app-loading>

<app-message-dialog></app-message-dialog>

<app-toast></app-toast>

<ngx-loading-bar></ngx-loading-bar>
